import React from 'react';

import ApplicationPackageJpg from './application-package.jpg';
import ApplicationPackageWebp from './application-package.webp';
import ApplicationPackageMobileJpg from './application-package-mobile.jpg';
import ApplicationPackageMobileWebp from './application-package-mobile.webp';
import ProfilePng from './profile-on-mobile.png';
import ProfileWebp from './profile-on-mobile.webp';
import DocumentPng from './document.png';
import DocumentWebp from './document.webp';
import DealPng from './deal.png';
import DealWebp from './deal.webp';
import { Modal } from '../../../../common/display/modal/Modal';
import { Benefit } from '../../../../../@types/benefits';
import { BenefitModalProps } from '../../../../../@types/benefitModalProps';
import { APP_CONFIG } from '../../../../../config';
import { ImageSource } from '../../../../common/display/imageSource/ImageSource';
import { OrderedList } from '../../../../common/display/orderedList/OrderedList';
import { Carousel } from './carousel/Carousel';
import { FAQTab } from '../../../../common/display/faqTab/FAQTab';
import { Msg, useIntl } from '@/i18n';
import { PlusBadge } from '@/components/common/display/plusBadge/PlusBadge';

const styles = {
  overviewTab: { maxWidth: 530 },
};

const OverviewTab = () => {
  return (
    <div style={styles.overviewTab}>
      <div className='font-heading-xsmall-regular padding-bottom-l'>
        <Msg
          id='benefits.applicationPackage.modal.overview.paragraph'
          defaultMessage='The ImmoScout24 application package contains...'
        />
      </div>
      <ul className='list-check list-spacing-s'>
        <li>
          <Msg id='benefits.applicationPackage.modal.overview.bullet1' defaultMessage='Automatic creation and...' />
        </li>
        <li>
          <Msg id='benefits.applicationPackage.modal.overview.bullet2' defaultMessage='In high-quality design...' />
        </li>
        <li>
          <Msg id='benefits.applicationPackage.modal.overview.bullet3' defaultMessage='Providers trust the...' />
        </li>
        <li>
          <Msg
            id='benefits.applicationPackage.modal.overview.bullet4'
            defaultMessage='Exclusive & free...'
            values={{
              BuyerPlusLogo: <PlusBadge variant='buy' />,
            }}
          />
        </li>
      </ul>
      <div className='margin-vertical-l'>
        <Carousel />
      </div>
    </div>
  );
};

const HowItWorksTab = () => {
  const { t } = useIntl();
  const Item = OrderedList.Item;

  return (
    <div className='margin-bottom-xxl'>
      <OrderedList>
        <Item
          image={
            <ImageSource
              image={ProfilePng}
              imageWebp={ProfileWebp}
              imageAlt={t({
                id: 'benefits.applicationPackage.modal.howItWorks.image1',
                defaultMessage: 'your profile',
              })}
              sizes='100px'
            />
          }
          text={t({
            id: 'benefits.applicationPackage.modal.howItWorks.paragraph1',
            defaultMessage: 'generate your application package in minutes',
          })}
        />
        <Item
          image={
            <ImageSource
              image={DocumentPng}
              imageWebp={DocumentWebp}
              imageAlt={t({
                id: 'benefits.applicationPackage.modal.howItWorks.image2',
                defaultMessage: 'application package on paper and digital',
              })}
              sizes='100px'
            />
          }
          text={t({
            id: 'benefits.applicationPackage.modal.howItWorks.paragraph2',
            defaultMessage: 'click to generate document...',
          })}
        />
        <Item
          image={
            <ImageSource
              image={DealPng}
              imageWebp={DealWebp}
              imageAlt={t({
                id: 'benefits.applicationPackage.modal.howItWorks.image3',
                defaultMessage: 'contract',
              })}
              sizes='100px'
            />
          }
          text={t({
            id: 'benefits.applicationPackage.modal.howItWorks.paragraph3',
            defaultMessage: 'download and print...',
          })}
        />
      </OrderedList>
    </div>
  );
};

const buttonArea = (
  <div className='align-center'>
    <a
      className='button-secondary button-rounded'
      href={`${APP_CONFIG.membershipPageUrl}?cmp_id=10-051667&cmp_name=myscout_buying_buy&cmp_position=residential_benefits_buy&cmp_creative=application_package_cta`}
    >
      <Msg id='benefits.applicationPackage.modal.linkButton' defaultMessage='To my application package' />
    </a>
  </div>
);

export const ApplicationPackage = ({ isVisible, onClose }: BenefitModalProps) => {
  const { t } = useIntl();

  return (
    <Modal
      title={t({ id: 'benefits.applicationPackage.headline', defaultMessage: 'Application package' })}
      isVisible={isVisible}
      image={ApplicationPackageJpg}
      imageWebp={ApplicationPackageWebp}
      imageMobile={ApplicationPackageMobileJpg}
      imageMobileWebp={ApplicationPackageMobileWebp}
      imageUseFullWidth={true}
      imageAlt={t({
        id: 'benefits.applicationPackage.modal.image',
        defaultMessage: 'Application package is handed over',
      })}
      tabsContent={[
        <OverviewTab key='benefits.applicationPackage.modal.overview' />,
        <HowItWorksTab key='benefits.applicationPackage.modal.howItWorks' />,
        <FAQTab
          key='benefits.applicationPackage.modal.faq'
          benefit='applicationPackage'
          values={{
            BuyerReportPageLink: (chunks: any) => (
              <a href={`${APP_CONFIG.membershipPageUrl}`} target='_blank' rel='noreferrer'>
                {chunks}
              </a>
            ),
          }}
        />,
      ]}
      buttonArea={buttonArea}
      benefit={Benefit.APPLICATION_PACKAGE}
      onClose={onClose}
    />
  );
};
